export default "__VITE_ASSET__CGA4cgGP__"